export interface LogDetailResponse {
    dbResults?: LogDetail[];
    totalCount?: TotalCount[];
}

/**
 * Deliverect日志
 */
export type DeliverectLogDetail = {
    _id?: string;
    /**
     * 日期
     */
    date?: string;
    /**
     * 订单详情 | 菜品同步详情 | 错误详情
     */
    detail?: LogDetail & ReportDetails;
    /**
     * 集团名称
     */
    group_nickname?: string;
    /**
     * 集团码
     */
    group_string_id?: string;
    /**
     * 操作员 "DELIVERECT" | "2.0"
     */
    operator?: string;
    /**
     * 来源 "deliverect"
     */
    origin?: string;
    /**
     * 餐厅名称
     */
    restaurant_nickname?: string;
    /**
     * 餐厅码
     */
    string_id?: string;
    /**
     * '0' | '1' | '2'  订单 菜品 错误
     */
    type?: string;
}

/**
 * 订单详情 | 菜品同步详情 | 错误详情
 */
export interface LogDetail {
    /**
     * 顾客信息
     */
    customer?: LogDetailCustomer;
    /**
     * 订单价格
     */
    order_price?: number;
    /**
     * Deliverect 订单状态
     */
    order_status?: DeliverectOrderStatus;
    /**
     * 2.0 订单的origin_id参数
     */
    orderId?: string;
}

/**
 * 顾客信息
 */
interface LogDetailCustomer {
    companyName: string;
    email: string;
    name: string;
    note: string;
    phoneAccessCode: string;
    phoneNumber: string;
}

interface TotalCount {
    count?: number;
}
/**
 *  Deliverect订单状态
 */
export enum DeliverectOrderStatus {
    // 1创建
    CREATE = 1,
    // 90完成
    COMPLETE = 90,
    // 110 2.0取消的订单， 100 deliverect取消的订单
    CANCEL = 100,
    CANCEL2 = 110,
    // Accepted is a confirmation the order is in the POS workflow
    ACCEPTED = 20
}


/**
 * 产品类型
 */
// enum ProductType {
//     // 1 产品 Product	A 'top level' item on a menu (can also be grouped within a modifier group or bundle)
//     Product = 1,
//     // 2 修饰符（调味品）Modifier	Options selectable when ordering a product, typically modifications of the product
//     Modifier = 2,
//     // 3 修饰符组（调味品组）A grouping of modifiers (can also group products)
//     Modifier_Group = 3,
//     // 4 捆绑包 （产品里的subproduct;套餐里面区域部分;)Can only contain products which are offered as part of a 'Meal Deal' and which Deliverect will set to zero value. Exception to this is where ## Overloads are set, see example 'Bundles (Product price overloads)' on the right hand side.
//     Bundle = 4
// }
type ReportDetails = {
    Area?: ReportDetailsItem;
    SetMeal?: ReportDetailsItem;
    dish?: ReportDetailsItem;
    Condiment?: ReportDetailsItem;
    CondimentGroup?: ReportDetailsItem;
} & ODConversionDeloverect

type ReportDetailsItem = {
    insertedCount: number;
    insertedIds: { [key: number]: string };
    ops: any[];
    result: {
        ok: 1
    }
}
/**
 * OD ---> Deliverect 成功后返回同步结果
 */
type ODConversionDeloverect = {
    products?: DeliverectConversionSnalysis;
    modifiers?: DeliverectConversionSnalysis;
    modifierGroups?: DeliverectConversionSnalysis;
    bundles?: DeliverectConversionSnalysis;
    errors?: number;
    priceLevels?: number;
    warnings?: number;
}

/**
 * Deliverect同步结果分析
 */
type DeliverectConversionSnalysis = {
    // 插入
    inserted: number;
    // 更新
    updated: number;
    // 删除
    deleted: number;
    // 忽略
    ignored: number;
}